import { useEffect, useRef, useState } from 'react'
import Icon from './icons.jsx'
import { useApp } from '../context/AppContext.jsx'

// Issues #93/#94: usuário vinculado a mais de uma organização (ex.: dono da
// própria org + membro de outra) precisa de um jeito explícito de saber e
// trocar em qual organização está operando — sem isso, tanto ações de
// escrita (criar client) quanto leituras (lista de clients, dashboards)
// podiam misturar dados de organizações diferentes. Espelha ClientSwitcher.jsx.
// Único ponto de escolha (sem tela de gate no login): no boot, sem escolha
// persistida, cai na primeira organização da lista — o usuário vê qual é
// aqui e troca se não for a que queria.
export default function OrganizationSwitcher() {
  const { organizations, activeOrganizationId, setActiveOrganizationId } = useApp() || {}
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    function onClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [])

  if (!organizations || organizations.length <= 1) return null

  const active = organizations.find((o) => o.organization_id === activeOrganizationId)
  const buttonLabel = active
    ? active.organization_name || active.organization_id
    : 'Selecionar organização'

  function handleSelect(orgId) {
    if (orgId !== activeOrganizationId) void setActiveOrganizationId(orgId)
    setOpen(false)
  }

  return (
    <div className="organization-switcher" ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="organization-switcher-btn"
        onClick={() => setOpen((v) => !v)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 10px',
          fontSize: 13,
          maxWidth: 220,
        }}
        title="Trocar organização ativa"
      >
        <span
          aria-hidden
          style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}
        >
          <Icon n="bank" s={14} />
        </span>
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {buttonLabel}
        </span>
        <Icon n={open ? 'chevron_u' : 'chevron_d'} s={12} />
      </button>
      {open && (
        <div
          className="organization-switcher-dropdown"
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            right: 0,
            minWidth: 220,
            maxWidth: 'calc(100vw - 32px)',
            background: 'var(--card, #fff)',
            border: '1px solid var(--border, #e5e5e7)',
            borderRadius: 8,
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            padding: 4,
            zIndex: 50,
          }}
        >
          {organizations.map((o) => {
            const isCurrent = o.organization_id === activeOrganizationId
            return (
              <button
                type="button"
                key={o.organization_id}
                className={`organization-switcher-option ${isCurrent ? 'active' : ''}`}
                onClick={() => handleSelect(o.organization_id)}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '8px 10px',
                  fontSize: 13,
                  borderRadius: 6,
                  background: isCurrent ? 'var(--bg-muted, #f5f5f7)' : 'transparent',
                  fontWeight: isCurrent ? 600 : 400,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {o.organization_name || o.organization_id}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
